const inlineRadios = (editor) => {

    editor.BlockManager.add('Inline radios', {
        category: 'Components',
        label: `
            <div style={{display: 'flex', flexDirection : 'row'}}>
            <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
              width="1.2vw" height="1.2vw"  viewBox="0 0 465.088 465.089" style="enable-background:new 0 0 465.088 465.089;"
              xml:space="preserve">
            <g > 
              <path d="M61.21,171.335c-33.749,0-61.21,27.457-61.21,61.21c0,33.752,27.457,61.209,61.21,61.209s61.217-27.457,61.217-61.209
                C122.427,198.796,94.958,171.335,61.21,171.335z M61.21,279.298c-25.781,0-46.752-20.969-46.752-46.753
                c0-25.776,20.971-46.752,46.752-46.752c25.788,0,46.755,20.977,46.755,46.752C107.965,258.329,86.991,279.298,61.21,279.298z
                M465.088,195.445v74.189c0,3.196-2.591,5.789-5.78,5.789H155.637c-3.187,0-5.775-2.593-5.775-5.789v-74.189
                c0-3.182,2.588-5.776,5.775-5.776h303.663C462.498,189.669,465.088,192.263,465.088,195.445z"/>
            </g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg>
            <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
              width="1.2vw" height="1.2vw" viewBox="0 0 465.088 465.089" style="enable-background:new 0 0 465.088 465.089;"
              xml:space="preserve">
            <g>
              <path d="M61.21,171.335c-33.749,0-61.21,27.457-61.21,61.21c0,33.752,27.457,61.209,61.21,61.209s61.217-27.457,61.217-61.209
                C122.427,198.796,94.958,171.335,61.21,171.335z M61.21,279.298c-25.781,0-46.752-20.969-46.752-46.753
                c0-25.776,20.971-46.752,46.752-46.752c25.788,0,46.755,20.977,46.755,46.752C107.965,258.329,86.991,279.298,61.21,279.298z
                M465.088,195.445v74.189c0,3.196-2.591,5.789-5.78,5.789H155.637c-3.187,0-5.775-2.593-5.775-5.789v-74.189
                c0-3.182,2.588-5.776,5.775-5.776h303.663C462.498,189.669,465.088,192.263,465.088,195.445z"/>
            </g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg>
            <div>
            <div class="gjs-fontFamily gjs-block-label">Inline radios </div>`,
        attributes: {},
        content: `
              <div class="form-check form-check-inline" wablitype ='radios'>
                <input class="form-check-input" type="radio"  checked id="inlineRadio1" value="1"/>
                <label class="form-check-label" for="inlineRadio1">1</label>
              </div>
              <div class="form-check form-check-inline" wablitype ='radios'>
                <input class="form-check-input" type="radio"  id="inlineRadio2" value="2"/>
                <label class="form-check-label" for="inlineRadio2">2</label>
              </div>

            `
      });
}

export default inlineRadios;